import React from 'react'
import { Skill } from '../../../interfaces/Skill';
import '../interpersonal_skills/interpersonal_skills.css';

interface ChipItemProps {
	skill: Skill;
}

const ChipItem: React.FC<ChipItemProps> = ({ skill }) => {

	return (
		<div className={`chip-item`}>
			<div
				className='title'
			>
				<h3>{skill.skillName}</h3>
			</div>
		</div>
	)
}

export default ChipItem;